import { useMemo } from "react";
import { ConnectionName } from "@arelia-types/connection";
import useRequiredConnections from "@arelia-utils/helpers/useRequiredConnections";
import GenderPresenter from "./GenderPresenter";
import { useAudience } from "../../api/streaming";
import { useAudienceArtistFilter } from "@arelia-hooks/artistAccount";

export default function GenderContainer() {
  const requiredConnectionNames = [ConnectionName.youtube, ConnectionName.spotify];
  const hasRequiredConnections = useRequiredConnections(requiredConnectionNames);
  const { data, isLoading, isError } = useAudience({ enabled: hasRequiredConnections });
  const filteredData = useAudienceArtistFilter(data);

  const genderStat = useMemo(() => {
    if (!filteredData) return { male: 0, female: 0 };
    const totalAudience = filteredData.gender.male + filteredData.gender.female;
    return {
      male: +(filteredData.gender.male / totalAudience * 100).toFixed(0),
      female: +(filteredData.gender.female / totalAudience * 100).toFixed(0)

    };
  }, [filteredData]);

  return <GenderPresenter loading={isLoading} male={genderStat.male} female={genderStat.female} error={isError} unconnected={!hasRequiredConnections} />;
}
